import LiveBackground, { useLiveBackground } from "../../liveBackground/LiveBackground";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ResultKPDay from "./day/ResultKPDay";
import ResultKPNight from "./ng/ResultKPNight";
import { drawingV2 } from "../../../constant/initDrawing";
import { getDateTime } from "../../../utility/dateUtils";
import Welcome from "../Welcome";
import LayoutWrapper from "../mt/LayoutWrapper";




const Live2KPWrapper = ({ config, socket }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const backgroundType = useLiveBackground();
    const [currentResult, setCurrentResult] = useState(drawingV2);
    const [result, setResult] = useState(drawingV2);
    const [column, setColumn] = useState(3);

    useEffect(() => {
        socket.on(`kp_result`, (payload) => {
            setCurrentResult(payload);
            if (payload?.slotResults?.length !== column) {
                setColumn(payload?.slotResults?.length);
            }
            if (result.results.length === 0 || result.isInited) {
                setResult(payload)
            }
        });

        return () => {
            socket.off(`kp_result`);
        }
    }, [socket, result, column]);

    const onStartDraw = (result) => {
        setResult(result)
    }




    if (result.results.length === 0) return <Welcome onStartDraw={onStartDraw} />

    return <LiveBackground result={result} className="d-flex justify-content-center overflow-hidden mt-2">
        <button
            type="button"
            className="welcome-back-button"
            onClick={() => navigate(backgroundType
                ? location.pathname.startsWith("/live-v4/") ? "/live-v4" : "/live-full"
                : "/")}
        >
            Back
        </button>
        <div>
            <div className="live-draw-heading d-flex justify-content-center align-items-center mb-3 title-kp text-info">
                <span className="mr-4">
                    KP
                </span> {getDateTime(result?.drawAt)}
            </div>
            <LayoutWrapper >
                {!result.isNight ? <ResultKPDay
                    setResult={setResult}
                    column={column}
                    currentResult={currentResult}
                    result={result}
                    config={config} />
                    : <ResultKPNight
                        setResult={setResult}
                        column={column}
                        currentResult={currentResult}
                        result={result}
                        config={config} />}
            </LayoutWrapper>

        </div>
    </LiveBackground>

};


export default Live2KPWrapper;
